export enum ProductPricingModel {
  Price = 'PRICE',
  Total = 'TOTAL',
}
